export default "__VITE_ASSET__xehDOtft__"